<template>
  <div class="container">
    <div class="back-btn">
      <a href="javascript:history.back();">&laquo; Back To All Athletes</a>
    </div>

    <div class="box-container">
      <div class="switch-tab">
        <!--  <button
          @click="tabOpen=='info' ? tabOpen = 'list' : tabOpen='info'"
          :class="{'active' : tabOpen=='info'}"
        >Info</button>

        <button
          @click="tabOpen=='info' ? tabOpen = 'list' : tabOpen='info'"
          :class="{'active' : tabOpen=='list'}"
        >List</button>-->
      </div>

      <div class="informations">
        <div class="info">
          <div class="title">Info</div>
          <img
            class="photo-user"
            v-if="highSchoolLoaded && clubLoaded && athlete.photoURL"
            :src="athlete.photoURL"
          />

          <img
            class="photo-user"
            v-if="highSchoolLoaded && clubLoaded && !athlete.photoURL"
            src="../assets/no-avatar.png"
          />
          <table v-if="highSchoolLoaded && clubLoaded">
            <tr>
              <td>
                <b>First Name:</b>
              </td>
              <td>{{ athlete.firstName }}</td>
            </tr>
            <tr>
              <td>
                <b>Last Name:</b>
              </td>
              <td>{{ athlete.lastName }}</td>
            </tr>
            <tr>
              <td>
                <b>Email:</b>
              </td>
              <td>
                <a :href="`mailto:${athlete.email}`">{{ athlete.email }}</a>
                <button
                  class="clipboad"
                  v-clipboard:copy="athlete.email"
                  v-clipboard:success="onCopy"
                >
                  Copy to clipboard
                </button>
              </td>
            </tr>
            <tr>
              <td>
                <b>Parent Name:</b>
              </td>
              <td>{{ athlete.parentName }}</td>
            </tr>
            <tr>
              <td>
                <b>Parent Email:</b>
              </td>
              <td>
                <a :href="`mailto:${athlete.parentEmail}`">{{
                  athlete.parentEmail
                }}</a>
              </td>
            </tr>
            <tr>
              <td>
                <b>Phone:</b>
              </td>
              <td>{{ athlete.phone }}</td>
            </tr>
            <tr>
              <td>
                <b>Grad Yr:</b>
              </td>
              <td>{{ athlete.graduatingYear }}</td>
            </tr>
            <tr>
              <td>
                <b>Position:</b>
              </td>
              <td>{{ athlete.position.name }}</td>
            </tr>
            <tr>
              <td>
                <b>High School:</b>
              </td>
              <td>
                <a
                  v-if="highSchool"
                  @click="$router.push(`/highSchools/${highSchool.id}`)"
                  >{{ highSchool.name }}</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <b>HS Coach:</b>
              </td>
              <td>{{ athlete.highSchoolCoachName }}</td>
            </tr>
            <tr>
              <td>
                <b>HS Coach Email:</b>
              </td>
              <td>
                <a :href="`mailto:${athlete.highSchoolCoachEmail}`">{{
                  athlete.highSchoolCoachEmail
                }}</a>
              </td>
            </tr>
            <tr>
              <td>
                <b>HS Coach Phone:</b>
              </td>
              <td>{{ athlete.highSchoolCoachPhone }}</td>
            </tr>
            <tr>
              <td>
                <b>HS Jersey #:</b>
              </td>
              <td>{{ athlete.schoolJerseyNumber }}</td>
            </tr>
            <tr>
              <td>
                <b>Club Team:</b>
              </td>
              <td>
                <a v-if="club" @click="$router.push(`/clubs/${club.id}`)">{{
                  club.name
                }}</a>
              </td>
            </tr>
            <tr>
              <td>
                <b>Club Coach:</b>
              </td>
              <td>{{ athlete.clubCoachName }}</td>
            </tr>
            <tr>
              <td>
                <b>Club Email:</b>
              </td>
              <td>{{ athlete.clubCoachEmail }}</td>
            </tr>
            <tr>
              <td>
                <b>Club Phone:</b>
              </td>
              <td>{{ athlete.clubCoachPhone }}</td>
            </tr>
            <tr>
              <td>
                <b>Club Jersey #:</b>
              </td>
              <td>{{ athlete.clubJerseyNumber }}</td>
            </tr>
            <tr>
              <td>
                <b>Highlight Video:</b>
              </td>
              <td>
                <a
                  :href="`${
                    athlete.highlightVideo &&
                    athlete.highlightVideo.includes('http')
                      ? athlete.highlightVideo
                      : 'https://' + athlete.highlightVideo
                  }`"
                  target="_blank"
                  >{{ athlete.highlightVideo }}</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <b>GPA:</b>
              </td>
              <td>{{ athlete.gpa }}</td>
            </tr>
            <tr>
              <td>
                <b>SAT Score:</b>
              </td>
              <td>{{ athlete.sat }}</td>
            </tr>
            <tr>
              <td>
                <b>ACT Score:</b>
              </td>
              <td>{{ athlete.act }}</td>
            </tr>
            <tr>
              <td>
                <b>Address:</b>
              </td>
              <td>{{ athlete.address ? athlete.address.street : "" }}</td>
            </tr>
            <tr>
              <td>
                <b>City:</b>
              </td>
              <td>{{ athlete.address ? athlete.address.city : "" }}</td>
            </tr>
            <tr>
              <td>
                <b>State/Province:</b>
              </td>
              <td>{{ athlete.address ? athlete.address.state : "" }}</td>
            </tr>
            <tr>
              <td>
                <b>Zip:</b>
              </td>
              <td>{{ athlete.address ? athlete.address.zip : "" }}</td>
            </tr>
          </table>
        </div>

        <div class="list">
          <div class="title">Schedule</div>
          <!-- <table v-if="events.length > 0">
              <tr v-for="(event, index) in events" :key="index">
                <td><b>Name:</b></td>
                <td><a @click="$router.push(`/events/${event.id}`)">{{event.name}}</a>&nbsp;|</td>
                <td><b>Start:&nbsp;</b></td>
                <td>{{event.startDate ? event.startDate.toDate().getMonth()+1 + '/' + event.startDate.toDate().getDate() + '/' + event.startDate.toDate().getFullYear() : ''}}</td>
                <td><b>End:&nbsp;</b></td>
                <td>{{event.endDate ? event.endDate.toDate().getMonth()+1 + '/' + event.endDate.toDate().getDate() + '/' + event.endDate.toDate().getFullYear() : ''}}</td>
              </tr>
          </table>-->
          <ul v-if="events.length > 0">
            <li v-for="(event, index) in events" :key="index">
              <b>Name:&nbsp;</b>
              <a @click="$router.push(`/events/${event.id}`)">{{
                event.name
              }}</a
              >&nbsp;|
              <b>Start:&nbsp;</b>
              {{
                event.startDate
                  ? event.startDate.toDate().getMonth() +
                    1 +
                    "/" +
                    event.startDate.toDate().getDate() +
                    "/" +
                    event.startDate.toDate().getFullYear()
                  : ""
              }}
              <b>End:&nbsp;</b>
              {{
                event.endDate
                  ? event.endDate.toDate().getMonth() +
                    1 +
                    "/" +
                    event.endDate.toDate().getDate() +
                    "/" +
                    event.endDate.toDate().getFullYear()
                  : ""
              }}
            </li>
          </ul>
          <h1 v-else>No events to show</h1>
        </div>
      </div>
    </div>
  </div>
</template>


  <script>
import { db } from "../db";
import router from "../router";
import firebase from "firebase/app";

export default {
  data() {
    return {
      athlete: null,
      highSchool: null,
      club: null,
      highSchoolLoaded: false,
      clubLoaded: false,
      tabOpen: "info",
      events: [],
    };
  },
  async created() {
    /* THIS IS THE NEW FEATURE. It is commented because every time a coache is visiting an athlete a new action document is created with every refresh.
    Maybe we should consider a mechanism about NOT creating a document if a coach has visited the athlete in the same day or something like that. */

    const uid = firebase.auth().currentUser.uid;
    const doc = await db.doc(`coaches/${uid}`).get();
    const docData = doc.data();

    let payload = {
      info: {},
    };

    payload.dateCreated = new Date();
    payload.device = "web";
    payload.fromUser = doc.ref;

    if (docData.college) {
      payload.info.college = docData.college;
    }

    if (docData.division) {
      payload.info.division = docData.division;
    }

    if (docData.conference) {
      payload.info.conference = docData.conference;
    }

    payload.toUser = db.doc(`athletes/${this.$route.params.id}`);

    payload.type = "profileView";

    try {
      await db
        .collection("actions")
        .doc()
        .set({ ...payload });
    } catch (err) {
      alert(err);
    }

    /* END OF NEW FEATURE */

    db.collection("athletes")
      .doc(this.$route.params.id)
      .get()
      .then((athlete) => {
        this.athlete = athlete.data();

        if (this.athlete.position) {
          db.doc(this.athlete.position.path)
            .get()
            .then((position) => {
              this.athlete.position = {
                name: position.data().name,
                ref: position.ref,
              };
            });
        }

        if (this.athlete.highSchool) {
          db.doc(this.athlete.highSchool.path)
            .get()
            .then((highSchool) => {
              this.highSchool = {
                ...highSchool.data(),
                id: highSchool.id,
              };
              this.highSchoolLoaded = true;
            });
        } else {
          this.highSchoolLoaded = true;
        }

        if (this.athlete.club) {
          db.doc(this.athlete.club.path)
            .get()
            .then((club) => {
              this.club = {
                ...club.data(),
                id: club.id,
              };
              this.clubLoaded = true;
            });
        } else {
          this.clubLoaded = true;
        }

        if (this.athlete.attendingEvents) {
          this.athlete.attendingEvents.forEach((event) => {
            db.doc(event.path)
              .get()
              .then((eventData) => {
                if (eventData.data()) {
                  this.events.push({ ...eventData.data(), id: eventData.id });
                }
              });
          });
        }
      });
  },
  methods: {
    onCopy(e) {
      alert("You just copied: " + e.text);
    },
  },
};
</script>

<style lang="scss" scoped>
.informations {
  display: flex;
}

.info {
  width: 50%;
  border-right: 1px solid #707070;
  border-left: 1px solid #707070;
}

.list {
  padding: 20px;
}

.list ul li a {
  color: #1a348d;
}

img.photo-user {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  display: block;
  padding: 20px;
  margin: 0 auto;
}

table {
  border-top: 1px solid #707070;
}

table tr th:nth-child(2),
table tr td:nth-child(2) {
  border-right: none;
}

table tr th:first-child,
table tr td:first-child {
  border-right: 1px solid #707070;
}

table tr td:first-child {
  text-align: right;
}

.list {
  flex: 1;
  padding: 0 !important;

  ul {
    padding: 0 20px;
  }
}

.list,
.info {
  .title {
    width: 100%;
    text-align: center;
    padding: 20px 0;
    border-bottom: 1px solid black;
    font-size: 24px;
  }
}
</style>